import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { shareReplay } from "rxjs/operators";
import { AnalistaService } from "./api-analista.service";
import { RegisterAccess } from "../../../app/shared/Entities/RegisterAccess";
import { CriarCompromissoSignature } from "../../../app/shared/Signature/CriarCompromissoSignature";
import { AtualizarCompromissoSignature } from "../../../app/shared/Signature/AtualizarCompromissoSignature";
import { AlocaUsuarioResponsavelSignature } from "../../../app/shared/Signature/AlocaUsuarioResponsavelSignature";
import { CarregarListaOperacionalFiltrosSignature } from "../../../app/shared/Signature/CarregarListaOperacionalFiltrosSignature";

@Injectable({
  providedIn: 'root'
})

export class AnalistaDataService {

  private analistaCache$: Observable<any> = null;
  private analistaCacheTodos$: Observable<any> = null;

  constructor(private api: AnalistaService) {
  }

  /** Lista de analistas/usuários com cache: uma única chamada à API é compartilhada entre todos os consumidores. */
  public GetAnalista(): Observable<any> {
    if (!this.analistaCache$) {
      this.analistaCache$ = this.api.GetAnalista().pipe(shareReplay(1));
    }
    return this.analistaCache$;
  }

  public GetAnalistaTodos(): Observable<any> {
    if (!this.analistaCacheTodos$) {
      this.analistaCacheTodos$ = this.api.GetAnalistaTodos().pipe(shareReplay(1));
    }
    return this.analistaCacheTodos$;
  }

  /** Invalida o cache de analistas (ex.: após alteração de usuários). Próxima GetAnalista() fará nova requisição. */
  public invalidarCacheAnalista(): void {
    this.analistaCache$ = null;
  }

  public GetAnalistaBusca(): Observable<any> {
    return this.api.GetAnalistaBusca();
  }

  public RegistraAcesso(signature: RegisterAccess): Observable<any> {
    return this.api.RegistraAcesso(signature);
  }

  public GetTipoAnalista(): Observable<any> {
    return this.api.GetTipoAnalista();
  }

  public GetPopupEmployee(employeeId: string): Observable<any> {
    return this.api.GetPopupEmployee(employeeId);
  }

  public AlocaUsuarioResponsavel(signature: AlocaUsuarioResponsavelSignature): Observable<any> {
    return this.api.AlocaUsuarioResponsavel(signature);
  }

  public GetCompromissos(employeeId?: string, dataInicio?: Date, dataFim?: Date): Observable<any> {
    return this.api.GetCompromissos(employeeId, dataInicio, dataFim);
  }

  public CriarCompromisso(signature: CriarCompromissoSignature): Observable<any> {
    return this.api.CriarCompromisso(signature);
  }

  public AtualizarCompromisso(signature: AtualizarCompromissoSignature): Observable<any> {
    return this.api.AtualizarCompromisso(signature);
  }

  public DeletarCompromisso(id: string): Observable<any> {
    return this.api.DeletarCompromisso(id);
  }

  public GetAnalistaPorTipo(tipoUsuario: number): Observable<any> {
    return this.api.GetAnalistaPorTipo(tipoUsuario);
  }

  public GetListaAnalistaGerenteExecutivo(gerenteExecutivoId: string): Observable<any> {
    return this.api.GetListaAnalistaGerenteExecutivo(gerenteExecutivoId);
  }

  public GetUsuariosOperacional(): Observable<any> {
    return this.api.GetUsuariosOperacional();
  }
}
